export const FIN_TRANS_SERVICE = "/financial-transparency-sb/v0";
export const FIN_TRANS_PAYMENT = `${FIN_TRANS_SERVICE}/payment`;
export const FIN_TRANS_QUARTER = `${FIN_TRANS_SERVICE}/quarter`;
//-----------------
export const FIN_TRANS_ACTIVE_QUARTERS = `${FIN_TRANS_QUARTER}/by_school_year_id`; // /{schoolYearId}/index.json
export const FIN_TRANS_CURRENT_QUARTER = `${FIN_TRANS_QUARTER}/current/detail.json`;
export const FIN_TRANS_PAYMENTS_EXPORT = `${FIN_TRANS_PAYMENT}/search/export.csv`;
export const FIN_TRANS_PAYMENTS_SEARCHABLE = `${FIN_TRANS_PAYMENT}/searchable/index.json`;
export const FIN_TRANS_REPORTABLE_SCHOOL_YEARS = `${FIN_TRANS_QUARTER}/reportable_school_years/index.json`;
export const FIN_TRANS_SEARCH_LOG_CREATE = `${FIN_TRANS_SERVICE}/search_log/detail.json`;
